import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-map-generic-button',
  templateUrl: './map-generic-button.component.html',
  styleUrls: ['./map-generic-button.component.scss']
})
export class MapGenericButtonComponent implements OnInit {

  @Input() iconName = 'info';
  @Output() clicked = new EventEmitter();

  constructor() {
  }

  ngOnInit(): void {
  }
}
